document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".professional__tabs");
  const profileCards = document.querySelectorAll(".profile-card");

  tabButtons.forEach((tab) => {
    tab.addEventListener("click", function () {
      const selectedTab = this.getAttribute("data-professional-tab");

      // Remove active class from all tabs
      tabButtons.forEach((t) => t.classList.remove("active"));
      // Add active class to the clicked tab
      this.classList.add("active");

      if (selectedTab === "all") {
        // Show all cards
        profileCards.forEach((card) => card.classList.add("active"));
      } else {
        // Hide all cards
        profileCards.forEach((card) => {
          const cardTab = card.getAttribute("data-professional");
          if (cardTab === selectedTab) {
            card.classList.add("active");
          } else {
            card.classList.remove("active");
          }
        });
      }
    });
  });
});
